import i18next from 'i18next';

i18next.addResources('es', 'drawer', {
  close: 'Cerrar',
  open: 'Abrir',
  studies: 'Estudios',
  opensInNewTab: 'se abre en una pestaña nueva'
});

i18next.addResources('en', 'drawer', {
  close: 'Close',
  open: 'Open',
  studies: 'Studies',
  opensInNewTab: 'opens in a new tab'
});

i18next.addResources('pt', 'drawer', {
  close: 'Fechar',
  open: 'Abrir',
  studies: 'Estudos',
  opensInNewTab: 'abre em uma nova aba'
});
